<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Backup Schedules</h4>
      </div>
    </div>
    <div class="row">
      <div class="col-8">
        <router-link :to="{ name:'AdminBARScheduleAdd' }" class="btn btn-success"><i class="fa fa-edit"
                                                                                        aria-hidden="true"></i>
          Add Backup Schedule
        </router-link>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-10">
        <table class="table table-striped">
          <thead class="bg-hub-primary text-white">
          <tr>
            <th>Name</th>
            <th class="d-none d-md-table-cell">Location</th>
            <th>Schedule Time</th>
            <th class="d-none d-md-table-cell">Frequency</th>
            <th>Manage</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="backup_schedule in backup_schedules" :key="backup_schedule.backup_schedule_id">
            <td>
              {{ backup_schedule.name }}
            </td>
            <td class="d-none d-md-table-cell">
              {{ backup_schedule.backup_location.name }}
            </td>
            <td>
              {{ backup_schedule.schedule_time }}
            </td>
            <td class="d-none d-md-table-cell">
              {{ backup_schedule.backup_frequency.name }}
            </td>
            <td>
              <div class="dropdown">
                <button class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  <i class="fa fa-cogs fa-fw" aria-hidden="true"></i>
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                  <router-link :to="{ name:'AdminBARScheduleEdit', params: { backup_schedule_id: backup_schedule.backup_schedule_id } }"
                               class="dropdown-item"><i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>&nbsp;Edit
                  </router-link>
                  <a class="dropdown-item" href="#" onclick="return false" @click="deleteBackupSchedule(backup_schedule)"><i
                    class="fa fa-trash fa-fw"
                    aria-hidden="true"></i>&nbsp;Delete</a>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <p>
          <b>Backup Schedule Naming Conventions</b>
        </p>
        <p>
          Scheduled Backup creates a file which overwrites the previous file.
          Recommend naming conventions for "Scheduled" backups are Frequency_Time using hyphens "-" between the digits.
        </p>
        Example:
        <ul>
          <li>A weekly backup at 12:30 AM would read weekly_12-30-am</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  computed: mapGetters({
    backup_schedules: 'allBackupSchedules'
  }),
  created () {
    this.$store.dispatch('getBackupSchedules')
  },
  methods: {
    ...mapActions([
      'deleteBackupSchedule'
    ])
  }
}
</script>

<style scoped>

</style>
